import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';

import { allProductsState } from '../../recoil/atoms';
import { ShopNowCardFooter, ShopNowCardSection } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { ProductReviewQuote } from '../components/ProductReviewQuote';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { CardFooter } from '../../components/CardFooter';
import { useLanderControls } from '../LanderContext';

export const CrossOverBraLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };

  return (
    <>
      <CardBody>
        <LanderTopHero
          heroContainerHeight={'158vw'}
          heroImage={'mobile-crossoverbra-lander-top-hero-1.jpg'}
          title={'CrossOver Bra'}
          subTitle={'Sexy, meet supportive.'}
        >
          <HeroCallout
            orderIndex={0}
            label={
              <>
                Adjustable
                <br /> straps
              </>
            }
            labelColor={'black'}
            titleStyles={{ marginTop: -4 }}
            inlineStyles={{
              mobile: {
                right: `11%`,
                top: `54%`,
                flexDirection: 'row',
                alignItems: 'flex-start',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            titleStyles={{ marginTop: -4 }}
            label={
              <>
                Sexy mesh
                <br /> details.
              </>
            }
            inlineStyles={{
              mobile: {
                right: `56%`,
                top: `58%`,
                flexDirection: 'row',
                alignItems: 'flex-start',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            titleStyles={{ lineHeight: '22px' }}
            label={
              <>
                Soft,
                <br />
                Removable <br />
                cups
              </>
            }
            labelColor={'white'}
            inlineStyles={{
              mobile: {
                right: `11%`,
                top: `72%`,
                flexDirection: 'row-reverse',
                alignItems: 'flex-start',
              },
            }}
          />
          <HeroCallout
            orderIndex={3}
            label={
              <>
                Wire-free
                <br />
                support
              </>
            }
            titleStyles={{ lineHeight: '22px' }}
            inlineStyles={{
              mobile: {
                right: `52%`,
                top: `78%`,
                flexDirection: 'row-reverse',
                alignItems: 'flex-start',
              },
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-crossoverbra-desktop-1.jpg',
              title: 'Fully adjustable',
              description: 'Adjust the length of your straps or cross them in the back for more support.',
            },
            {
              imgName: 'feature-crossoverbra-desktop-2.jpg',
              title: 'Underwire-free lift',
              description: 'Bonding at the cradle lifts your chest for a supportive, comfortable fit.',
            },
            {
              imgName: 'feature-crossoverbra-desktop-3.jpg',
              title: 'Bonded seams',
              description: 'Stitch-free seams lay flat against skin for a seamless look under clothes.',
            },
          ]}
        />
        <ProductReviewQuote
          quoteText={
            <>
              “It’s actually supportive, which so many wireless bras claim to be but then don’t work for big boobs.
              <b>
                <i>You truly feel lifted</i>
              </b>{' '}
              and held up in this.”
            </>
          }
          author="TANYA E."
          imgName="crossover-bra-quote-mobile.png"
        />
        <ShopNowCardSection onClick={scrollToProductSection} />
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.CrossoverBra]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default CrossOverBraLanderMobile;
